// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadCatButton_button__aL9l1","fa-cloud-upload-alt":"UploadCatButton_fa-cloud-upload-alt__6ibOF","link":"UploadCatButton_link__anBTn"};